import {
  INDEPENDENT_PAGE_TYPE,
  ATTRIBUTE_PAGE_TYPE,
  OPEN_ROLE_PAGE_TYPE,
  OPEN_ROLE_TYPE_KEY,
} from 'helpers/consts';
import { PageType } from 'helpers/typings';

function getPageType(entityType: any): PageType {
  if (entityType.typeKey === OPEN_ROLE_TYPE_KEY) {
    return OPEN_ROLE_PAGE_TYPE;
  }

  if (entityType.personClientFieldId) {
    return ATTRIBUTE_PAGE_TYPE;
  }

  return INDEPENDENT_PAGE_TYPE;
}

export default getPageType;
